module.exports = __webpack_public_path__ + "assets/img/mark_green.96508971.svg";